/**
 * DEV-1860 (эпик DEV-1850). i18n раздела «Аналитика → Лендинги и кампании».
 * Overlay-модуль: подмешивается deepMerge поверх базовых локалей.
 *
 * Заменяет словарь под-таба «Лендинги» из «Отчётов» (DEV-1090): отчёт переехал
 * в свой раздел и оброс динамикой, структурой источников и кампаниями.
 */
export const marketingAnalyticsMessages = {
  ru: {
    common: {
      navigation: {
        analyticsMarketing: 'Лендинги и кампании',
      },
    },
    marketingAnalytics: {
      title: 'Лендинги и кампании',
      export: 'Экспорт XLSX',
      exportFailed: 'Выгрузку собрать не удалось',
      presets: {
        today: 'Сегодня',
        week: '7 дней',
        month: '30 дней',
        quarter: '90 дней',
      },
      scope: {
        all: 'Все площадки',
        allNote: 'все площадки, включая основной сайт',
        landings: 'Только лендинги',
        landingsNote: 'все лендинги, без основного сайта',
      },
      scopeLine: '{scope} · {range} ({days} дн.). Сравнение — с предыдущими {days} дн.',
      kpi: {
        views: 'Просмотры',
        leads: 'Заявки',
        conversion: 'Конверсия',
        cpl: 'Стоимость заявки',
        // DEV-2430: что считается и за какой период.
        hints: {
          views:
            'Просмотры площадок выбранной области за период, сутки по Вьетнаму. Изменение — к тому же отрезку прошлого периода.',
          leads:
            'Заявки с площадок выбранной области за период. Изменение — к тому же отрезку прошлого периода.',
          conversion:
            'Заявки на просмотры за период, в процентах. Изменение — в процентных пунктах.',
          cpl: 'Расход кампаний области за дни периода (доля бюджета) на заявки этих же кампаний. Основной сайт и неразмеченные переходы в цену не входят.',
        },
        cplHint: 'расход {value} — доля бюджета кампаний за эти дни',
        cplNoSpend: 'расход кампаний не задан',
        cplCatalogFailed: 'каталог кампаний не загрузился — расход неизвестен',
        noViews: 'просмотров нет — конверсию не из чего считать',
        leadsExceedViews: 'заявок больше, чем просмотров: часть визитов маячок не записал',
      },
      chart: {
        title: 'Динамика по дням',
        hint: 'Столбики — просмотры (левая ось), линия — заявки (правая). Пунктир — день запуска кампании. Какие кампании шли, видно в подсказке дня.',
        campaigns: 'Кампании:',
        launched: '{title} — запуск',
        more: 'и ещё {rest}',
        views: 'просмотры',
        leads: 'заявки',
        empty: 'За период просмотров не было',
      },
      sources: {
        title: 'Структура источников',
        source: 'Источник',
        medium: 'Канал',
        untagged: 'без метки',
        hint: 'Доли считаются по заявкам. «Без метки» — переходы по неразмеченной ссылке.',
        empty: 'За период заявок с метками не было',
      },
      landings: {
        title: 'Площадки',
        hint: 'Строка выбирает площадку: весь экран пересчитается по ней. Повторный клик снимает выбор.',
        noViews: 'нет просмотров',
        leadsExceedViews: 'заявок больше просмотров',
        landing: 'Площадка',
        views: 'Просмотры',
        leads: 'Заявки',
        conversion: 'Конверсия',
        site: 'Основной сайт',
        siteNote: 'vinprop.vn',
        native: 'на vinprop.vn',
        external: 'внешняя площадка',
        empty: 'За период просмотров площадок не было',
      },
      events: {
        title: 'Взаимодействия',
        scroll: 'Глубина прокрутки',
        clicks: 'Нажатия',
        submits: 'Отправок формы: {count}',
        readToEnd: 'дочитали до конца: {share}',
        empty:
          'За период взаимодействий не было. Они собираются с площадок, где стоит скрипт статистики.',
        labels: {
          unnamed: 'без метки',
          'cta-form': 'Кнопка заявки',
          phone: 'Телефон',
          email: 'Почта',
          whatsapp: 'WhatsApp',
          telegram: 'Telegram',
          zalo: 'Zalo',
        },
      },
      campaigns: {
        title: 'Кампании',
        hint: 'строка раскрывается до ссылок',
        scopedHint: 'только кампании выбранной площадки',
        leadsExceedViews: 'заявок больше просмотров',
        campaign: 'Кампания',
        target: 'Цель',
        views: 'Просмотры',
        leads: 'Заявки',
        conversion: 'Конверсия',
        spend: 'Расход за период · CPL',
        unknown: 'Кампания вне списка',
        untagged: 'Без кампании',
        untaggedNote: 'переходы по неразмеченным ссылкам',
        empty: 'За период размеченных переходов не было',
      },
    },
  },
  en: {
    common: {
      navigation: {
        analyticsMarketing: 'Landings & campaigns',
      },
    },
    marketingAnalytics: {
      title: 'Landings and campaigns',
      export: 'Export XLSX',
      exportFailed: 'The export could not be built',
      presets: {
        today: 'Today',
        week: '7 days',
        month: '30 days',
        quarter: '90 days',
      },
      scope: {
        all: 'All pages',
        allNote: 'all pages, main site included',
        landings: 'Landings only',
        landingsNote: 'all landings, without the main site',
      },
      scopeLine: '{scope} · {range} ({days}d). Compared with the previous {days} days.',
      kpi: {
        views: 'Views',
        leads: 'Leads',
        conversion: 'Conversion',
        cpl: 'Cost per lead',
        hints: {
          views:
            'Views of the selected area’s pages in the period, days in Vietnam time. Change — against the same stretch of the previous period.',
          leads:
            'Leads from the selected area’s pages in the period. Change — against the same stretch of the previous period.',
          conversion: 'Leads per views in the period, in percent. Change — in percentage points.',
          cpl: 'Spend of the area’s campaigns for the days of the period (share of budget) per lead of those campaigns. The main site and untagged visits are not included.',
        },
        cplHint: 'spend {value} — the share of campaign budgets for these days',
        cplNoSpend: 'campaign spend not set',
        cplCatalogFailed: 'campaign catalog failed to load — spend unknown',
        noViews: 'no views — nothing to divide by',
        leadsExceedViews: 'more leads than views: some visits were not recorded by the beacon',
      },
      chart: {
        title: 'Daily dynamics',
        hint: 'Bars are views (left axis), the line is leads (right). A dashed line marks a campaign launch. Hover a day to see which campaigns ran.',
        campaigns: 'Campaigns:',
        launched: '{title} — launch',
        more: 'and {rest} more',
        views: 'views',
        leads: 'leads',
        empty: 'No views in this period',
      },
      sources: {
        title: 'Source mix',
        source: 'Source',
        medium: 'Medium',
        untagged: 'untagged',
        hint: 'Shares are counted by leads. “Untagged” means visits through links without tags.',
        empty: 'No tagged leads in this period',
      },
      landings: {
        title: 'Landings',
        hint: 'A row picks a page: the whole screen is recounted for it. Click again to clear.',
        noViews: 'no views',
        leadsExceedViews: 'more leads than views',
        landing: 'Landing',
        views: 'Views',
        leads: 'Leads',
        conversion: 'Conversion',
        site: 'Main site',
        siteNote: 'vinprop.vn',
        native: 'on vinprop.vn',
        external: 'external site',
        empty: 'No landing views in this period',
      },
      events: {
        title: 'Interactions',
        scroll: 'Scroll depth',
        clicks: 'Taps',
        submits: 'Form submissions: {count}',
        readToEnd: 'read to the end: {share}',
        empty:
          'No interactions in this period. They come from pages that carry the metrics script.',
        labels: {
          unnamed: 'unlabelled',
          'cta-form': 'Request button',
          phone: 'Phone',
          email: 'Email',
          whatsapp: 'WhatsApp',
          telegram: 'Telegram',
          zalo: 'Zalo',
        },
      },
      campaigns: {
        title: 'Campaigns',
        hint: 'a row expands into its links',
        scopedHint: 'campaigns of the selected page only',
        leadsExceedViews: 'more leads than views',
        campaign: 'Campaign',
        target: 'Target',
        views: 'Views',
        leads: 'Leads',
        conversion: 'Conversion',
        spend: 'Spend in period · CPL',
        unknown: 'Campaign outside the list',
        untagged: 'No campaign',
        untaggedNote: 'visits through untagged links',
        empty: 'No tagged visits in this period',
      },
    },
  },
  vn: {
    common: {
      navigation: {
        analyticsMarketing: 'Trang đích và chiến dịch',
      },
    },
    marketingAnalytics: {
      title: 'Trang đích và chiến dịch',
      export: 'Xuất XLSX',
      exportFailed: 'Không tạo được tệp xuất',
      presets: {
        today: 'Hôm nay',
        week: '7 ngày',
        month: '30 ngày',
        quarter: '90 ngày',
      },
      scope: {
        all: 'Tất cả trang',
        allNote: 'tất cả trang, gồm cả trang chính',
        landings: 'Chỉ landing',
        landingsNote: 'tất cả landing, không tính trang chính',
      },
      scopeLine: '{scope} · {range} ({days} ngày). So với {days} ngày trước đó.',
      kpi: {
        views: 'Lượt xem',
        leads: 'Yêu cầu',
        conversion: 'Chuyển đổi',
        cpl: 'Giá mỗi yêu cầu',
        hints: {
          views:
            'Lượt xem các trang trong phạm vi đã chọn trong kỳ, theo ngày giờ Việt Nam. Thay đổi — so với cùng khoảng của kỳ trước.',
          leads:
            'Yêu cầu từ các trang trong phạm vi đã chọn trong kỳ. Thay đổi — so với cùng khoảng của kỳ trước.',
          conversion:
            'Yêu cầu trên lượt xem trong kỳ, tính theo phần trăm. Thay đổi — theo điểm phần trăm.',
          cpl: 'Chi phí chiến dịch của phạm vi cho các ngày trong kỳ (phần ngân sách) trên số yêu cầu của chính các chiến dịch đó. Không tính trang chính và lượt truy cập không gắn thẻ.',
        },
        cplHint: 'chi phí {value} — phần ngân sách chiến dịch cho những ngày này',
        cplCatalogFailed: 'không tải được danh mục chiến dịch — chưa rõ chi phí',
        noViews: 'không có lượt xem — không có gì để chia',
        leadsExceedViews: 'yêu cầu nhiều hơn lượt xem: một phần lượt truy cập chưa được ghi nhận',
        cplNoSpend: 'chưa nhập chi phí chiến dịch',
      },
      chart: {
        title: 'Diễn biến theo ngày',
        hint: 'Cột là lượt xem (trục trái), đường là yêu cầu (trục phải). Nét đứt là ngày ra mắt chiến dịch. Di chuột lên một ngày để xem chiến dịch nào đang chạy.',
        campaigns: 'Chiến dịch:',
        launched: '{title} — ra mắt',
        more: 'và {rest} chiến dịch khác',
        views: 'lượt xem',
        leads: 'yêu cầu',
        empty: 'Kỳ này không có lượt xem',
      },
      sources: {
        title: 'Cơ cấu nguồn',
        source: 'Nguồn',
        medium: 'Kênh',
        untagged: 'không thẻ',
        hint: 'Tỷ trọng tính theo yêu cầu. «Không thẻ» là lượt vào qua liên kết chưa gắn thẻ.',
        empty: 'Kỳ này không có yêu cầu gắn thẻ',
      },
      landings: {
        title: 'Trang đích',
        hint: 'Nhấn vào dòng để chọn trang: toàn màn hình sẽ tính lại theo trang đó. Nhấn lại để bỏ chọn.',
        noViews: 'không có lượt xem',
        leadsExceedViews: 'yêu cầu nhiều hơn lượt xem',
        landing: 'Trang đích',
        views: 'Lượt xem',
        leads: 'Yêu cầu',
        conversion: 'Chuyển đổi',
        site: 'Trang chính',
        siteNote: 'vinprop.vn',
        native: 'trên vinprop.vn',
        external: 'trang bên ngoài',
        empty: 'Kỳ này không có lượt xem trang đích',
      },
      events: {
        title: 'Tương tác',
        scroll: 'Độ sâu cuộn trang',
        clicks: 'Lượt nhấn',
        submits: 'Lượt gửi biểu mẫu: {count}',
        readToEnd: 'đọc hết trang: {share}',
        empty:
          'Kỳ này không có tương tác. Chúng được thu thập từ các trang có gắn tập lệnh thống kê.',
        labels: {
          unnamed: 'không nhãn',
          'cta-form': 'Nút gửi yêu cầu',
          phone: 'Điện thoại',
          email: 'Email',
          whatsapp: 'WhatsApp',
          telegram: 'Telegram',
          zalo: 'Zalo',
        },
      },
      campaigns: {
        title: 'Chiến dịch',
        hint: 'nhấn vào dòng để xem các liên kết',
        scopedHint: 'chỉ các chiến dịch của trang đã chọn',
        leadsExceedViews: 'yêu cầu nhiều hơn lượt xem',
        campaign: 'Chiến dịch',
        target: 'Đích đến',
        views: 'Lượt xem',
        leads: 'Yêu cầu',
        conversion: 'Chuyển đổi',
        spend: 'Chi phí trong kỳ · CPL',
        unknown: 'Chiến dịch ngoài danh sách',
        untagged: 'Không có chiến dịch',
        untaggedNote: 'lượt truy cập qua liên kết không gắn thẻ',
        empty: 'Kỳ này không có lượt vào gắn thẻ',
      },
    },
  },
}
